import { Typography } from "@mui/material";

const VisualizationLabel = () => {
  return (
    <Typography variant="subtitle2" sx={{ color: "text.primary" }}>
      Visualizations
    </Typography>
  );
};

export default VisualizationLabel;
